// Config type and defaults for the Social Icons widget.

export type SocialPlatform = 'instagram' | 'x' | 'facebook' | 'tiktok' | 'whatsapp' | 'youtube' | 'snapchat' | 'linkedin' | 'pinterest' | 'telegram';

export type SocialLink = {
  platform: SocialPlatform;
  url: string;
};

export type SocialIconsConfig = {
  _type: 'social_icons';
  links: SocialLink[];
  size: 'sm' | 'md' | 'lg';
  style: 'solid' | 'outline' | 'soft' | 'plain';
  shape: 'rounded' | 'circle';
  color_mode: 'brand' | 'mono';
  align: 'start' | 'center' | 'end';
  label_ar?: string;
  label_en?: string;
};

export const SOCIAL_PLATFORMS: { key: SocialPlatform; label: string; brandColor: string }[] = [
  { key: 'instagram', label: 'Instagram', brandColor: '#E4405F' },
  { key: 'x', label: 'X (Twitter)', brandColor: '#000000' },
  { key: 'facebook', label: 'Facebook', brandColor: '#1877F2' },
  { key: 'tiktok', label: 'TikTok', brandColor: '#000000' },
  { key: 'whatsapp', label: 'WhatsApp', brandColor: '#25D366' },
  { key: 'youtube', label: 'YouTube', brandColor: '#FF0000' },
  { key: 'snapchat', label: 'Snapchat', brandColor: '#FFFC00' },
  { key: 'linkedin', label: 'LinkedIn', brandColor: '#0A66C2' },
  { key: 'pinterest', label: 'Pinterest', brandColor: '#E60023' },
  { key: 'telegram', label: 'Telegram', brandColor: '#26A5E4' },
];

export const DEFAULT_SOCIAL_ICONS_CONFIG: SocialIconsConfig = {
  _type: 'social_icons',
  links: [
    { platform: 'instagram', url: '' },
    { platform: 'x', url: '' },
    { platform: 'whatsapp', url: '' },
  ],
  size: 'md',
  style: 'soft',
  shape: 'circle',
  color_mode: 'brand',
  align: 'center',
};
